import { all } from 'redux-saga/effects';
import menuSaga from './menuSaga';
import shopSaga from './shopSaga';
import billSaga from './billSaga';
import authSaga from './authSaga';
import settingsSaga from './settingsSaga';

export default function* rootSaga() {
  yield all([menuSaga(), shopSaga(), billSaga(), authSaga(), settingsSaga()]);
}
